var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef, memo } from "react";
const SvgMarketplace16 = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5585 2H3.44152L2.10819 6H13.8918L12.5585 2ZM3.44152 0C2.58066 0 1.81638 0.55086 1.54415 1.36754L0.0883037 5.73509C0.0298171 5.91055 0 6.09429 0 6.27924C0 7.22959 0.77041 8 1.72076 8H14.2792C15.2296 8 16 7.22959 16 6.27924C16 6.09429 15.9702 5.91055 15.9117 5.73509L14.4558 1.36754C14.1836 0.55086 13.4193 0 12.5585 0H3.44152Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 7H3V14H13V7H15V16H1V7Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7 10H9V16H7V10Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.01361 6.8356L5.01361 0.835601L6.98639 1.1644L5.98639 7.1644L4.01361 6.8356Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0136 7.1644L9.01361 1.1644L10.9864 0.835601L11.9864 6.8356L10.0136 7.1644Z",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgMarketplace16);
const Memo = /*#__PURE__*/memo(ForwardRef);
export default Memo;